import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { merchantEndpoints } from "@/features/merchant/api/endpoints";
import type { MerchantSettlementConfigDto } from "@/features/merchant/api/dto";

/**
 * Configuration de reversement d'un marchand
 * (`GET /MerchantSettlementConfigs/merchant/{merchantId}`).
 */
export const useSettlementConfig = (merchantId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.MERCHANT_SETTLEMENT_CONFIG(merchantId),
    queryFn: () =>
      fetchDataGet<MerchantSettlementConfigDto>({
        url: merchantEndpoints.merchantSettlementConfigs.byMerchant(merchantId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(merchantId),
  });
